import React from 'react';
import { View } from 'react-native';
import Select, { createFilter } from 'react-select';
import AsyncSelect from 'react-select/async';
import {  customSelectStyles, customSelectDot } from 'root/globals/Form';
import _ from 'root/libs/exaforte/react/lodash';
import CustomFormInput from './CustomFormInput';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import styles from 'root/libs/exaforte/Defaults.less';

const selectStylesWithDot = {...customSelectStyles, ...{
    input: styles => ({ ...styles, ...customSelectDot() }),
    placeholder: styles => ({ ...styles, ...customSelectDot() }),
    singleValue: (styles, { data }) => ({ ...styles, ...customSelectDot(data.color) }),
}};

export default class CustomSelect extends CustomFormInput {
    constructor(props) {
        super(props);

        this.state          = {isFocused: false, offset: 0, value: null, show_form: false};
        this.current_value  = null;
        this._toggleForm    = this._toggleForm.bind(this);
        this._goBack        = this._goBack.bind(this);
        this.loadOptions    = _.debounce(this.loadOptions.bind(this), 300);
        this.limit          = this.props.limit || (_.size(this.props.options) > 35 || (this.props.info && !_.is_empty(this.props.info.query)) ? 35 : null);
    }
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {closeMenuOnSelect: true, filterOption: true, noOptionsMessage: true})};
    }
    
    getElement() {
        let props               = this.getSupportedProps();
        let styles              = this.props.styles || (_.size(this.props.options) > 0 && this.props.options[0].color && this.props.value && !this.isMultiple() ? selectStylesWithDot : customSelectStyles);
        props.defaultValue      = null;
        props.options           = _.cloneDeep(this.props.options);
        props.isMulti           = this.isMultiple();
        props.isDisabled        = this.props.disabled || false;
        props.closeMenuOnSelect = props.closeMenuOnSelect || (!props.isMulti);
        props.filterOption      = props.filterOption || createFilter({stringify: option => option.label + ''});

        if(!_.is_empty(this.props.value) || !_.is_empty(props.options))
        {
            // Dit gebruiken we omdat wanneer je via ajax zoek op X en dan een value select hij vervolgens die value niet meer ophaalt en dus ook niet kan tonen
            if(this.state.value && (this.props.action || this.limit || (this.props.info && !_.is_empty(this.props.info.query))))
            {
                let selected_value = this.state.value;
                
                if(!this.isMultiple())
                    selected_value = [selected_value];

                for(let i in selected_value)
                {
                    let found = false;

                    for(let x in props.options)
                    {
                        if(props.options[x].options)
                        {
                            if(!_.is_empty(_.filter(props.options[x].options, item => _.isEqual(_.format_input(item.value), _.format_input(selected_value[i].value)))))
                                found = true
                        }
                        else if(_.isEqual(_.format_input(props.options[x].value), _.format_input(selected_value[i].value)))
                            found = true

                        if(found)
                            break;
                    }

                    if(!found)
                        props.options.push(_.format_input(selected_value[i]));
                }
            }
            
            props.value = (this.isMultiple() ? [] : '');
            
            if(!_.is_empty(props.options) && !_.is_empty(this.props.value))
                for(let i in props.options)
                {
                    if(!props.options[i])
                        continue;
    
                    if(this.isMultiple())
                    {
                        if(props.options[i].options)
                            props.value = [...props.value, ..._.filter(props.options[i].options, item => this.props.value.toString().split(',').includes(item.value + ''))];
                        else if(this.props.value.toString().split(',').includes(props.options[i].value + ''))
                            props.value = [...props.value, props.options[i]];
                    }
                    else
                    {
                        if(props.options[i].options)
                            props.value = _.filter(props.options[i].options, item => _.isEqual(_.format_input(item.value), _.format_input(this.props.value)));
                        else if(_.isEqual(_.format_input(props.options[i].value), _.format_input(this.props.value)))
                            props.value = props.options[i];
                        
                        // Omdat het geen multiple is kunnen we bij een gevonden waarde de loop skippen
                        if(!_.is_empty(props.value))
                            break;
                    }
                }
            
            this.current_value = props.value;
        }

        if(!props.placeholder)
            props.placeholder = 'Kies een optie...';

        // Hier halen we alle gearchiveerde items weg die niet als waarde geselecteerd zijn. Zodat je niet een lege input krijgt terwijl er wel iets gevuld is.
        if(!_.is_empty(props.options))
            for(let i = _.size(props.options) - 1; i >= 0;i--)
            {
                if(!props.options[i])
                    continue;

                // Werkt met groepen
                if(props.options[i].options)
                {
                    for(let x = _.size(props.options[i].options) - 1; x >= 0;x--)
                        if(props.options[i].options[x].archived)
                        {
                            // Item is gearchiveerd en niet als waarde ingevuld.
                            if(this._spliceOption(props.options[i].options[x]))
                                props.options[i].options.splice(x, 1);
                        }
                    
                    if(_.is_empty(props.options[i].options))
                        props.options.splice(i, 1);
                }
                else if(props.options[i].archived)
                {
                    // Item is gearchiveerd en niet als waarde ingevuld.
                    if(this._spliceOption(props.options[i]))
                        props.options.splice(i, 1);
                }
            }

        if(this.props.hideOnEmpty && _.is_empty(props.options))
            return null;

        let SelectItem = Select;
        
        if(this.limit || (this.props.info && !_.is_empty(this.props.info.query)))
        {
            SelectItem = AsyncSelect;

            props.onMenuClose   = () => { if(this.state.offset != 0)this.setState({offset: 0}); };
            props.onKeyDown     = () => { if(this.state.offset != 0)this.setState({offset: 0}); }; // Als je gaat zoeken moet de offset weer teruggezet worden
            
            if(_.is_empty(this.props.info) || _.is_empty(this.props.info.query))
            {
                props.onMenuScrollToBottom  = () => { if(this.limit * this.state.offset < _.size(props.options))this.setState({offset: this.state.offset + 1}); };
                props.defaultOptions        = props.options.slice(0, (this.state.offset + 1) * this.limit);
            }
            else
                props.defaultOptions = true;

            props.loadOptions = this.loadOptions;
        }

        if(props.isMulti)
            props.components={GroupHeading: (group) => <TouchableArea onPress={() => this._onChange(_.union(this.state.value, group.data.options))} style={group.getStyles('groupHeading', group)}>{group.data.label}</TouchableArea>};
        else
            props.onMenuOpen = () => {
                setTimeout(() => {
                    let selectedEl = document.getElementsByClassName('ReactSelect__option--is-selected')[0];

                    if(selectedEl)
                        selectedEl.scrollIntoView({behavior:'smooth', block:'nearest', inline: 'start'});
              },15);
            };

        return <SelectItem inputId={this.props.field} styles={styles} classNamePrefix={'ReactSelect'} onFocus={() => this.setState({isFocused: true})} onBlur={() => this.setState({isFocused: false})} isClearable={(this.props.mandatory ? false : true)} data-error={!_.is_empty(this.props.error)} onChange={this._onChange} menuPortalTarget={(process.env.NODE_ENV === 'test' ? undefined : document.body)} {...props} />;
    }
    
    _spliceOption(option) {
        return (option.archived == 't' && ((this.isMultiple() && !_.some(_.format_input(this.current_value), _.format_input(option))) || (!this.isMultiple() && !_.isEqual(_.format_input(option.value), _.format_input(this.current_value.value)))));
    }
    
    _onChange(selectedItem) {
        if(selectedItem)
        {
            this.setState({value: selectedItem});
            this.props.onChangeText((this.isMultiple() ? _.map(selectedItem, item => item.value).join(',') : selectedItem.value), selectedItem);
        }
        else
        {
            this.setState({value: null});
            this.props.onChangeText(null);
        }
    }
    
    isMultiple() {
        return (this.props.isMulti || (!_.is_empty(this.props.info) && this.props.info.multiple == 't'));
    }
    
    loadOptions(inputValue, callback) {
        if(_.is_empty(this.props.info) || _.is_empty(this.props.info.query))
        {
            if(!_.is_empty(inputValue))
            {
                let options = [];
                
                // Gegroupeerd
                if(this.props.options[0].options)
                {
                    for(let i in this.props.options)
                    {
                        if(_.includes(this.props.options[i].label.toString().toLowerCase(), inputValue.toString().toLowerCase()))
                            options.push(this.props.options[i]);
                        else if(!_.is_empty(this.props.options[i].options))
                        {
                            let group_options = [];

                            for(let x in this.props.options[i].options)
                                if(_.includes(this.props.options[i].options[x].label.toString().toLowerCase(), inputValue.toString().toLowerCase()) && !this._spliceOption(this.props.options[i].options[x]))
                                    group_options.push(this.props.options[i].options[x]);

                            if(!_.is_empty(group_options))
                                options.push({label: this.props.options[i].label, options: group_options})
                        }
                    }
                }
                else
                    options = this.props.options.filter(option => _.includes(option.label.toString().toLowerCase(), inputValue.toString().toLowerCase()) && !this._spliceOption(option));

                callback(_.slice(options, 0, (this.state.offset+1) * this.limit));
            }
            else
                callback(this.props.options.slice(0, this.state.offset * this.limit));
        }
        else
        {
            fetch(this.props.info.query + '&offset=' + this.state.offset + '&limit=' + this.limit + '&filter=' + inputValue.toString(), {method: 'POST', body: _.json_to_form_data(this.props.info.query_data || {}), xhrFields: { withCredentials: true }, credentials: 'include'}).then((response) => response.json()).then(response => {
                if(response.status)
                    callback(response.options);
                else
                    callback([]);
            });
        }
    }
    
    _toggleForm() {
        this.setState({show_form: !this.state.show_form});
    }
    
    _goBack(response) {
        if(response && response.status)
        {
            if(this.props.fielddefine)
                this.props.fielddefine.options.push({value: response.data.id, label: response.data.title});

            // We moeten de nieuwe optie ook weer in de fielddefine zetten, anders komt hij niet terug wanneer je een ander form binnen dezelfde pagina zou openen met hetzelfde component.
            if(this.props.action.root_component)
                this.props.action.root_component.setState(state => {
                    let newState = _.cloneDeep(state);

                    if(newState.fielddefines && newState.fielddefines[this.props.model.config.name] && newState.fielddefines[this.props.model.config.name][this.props.fielddefine.field])
                        newState.fielddefines[this.props.model.config.name][this.props.fielddefine.field].options.push({value: response.data.id, label: response.data.title});
                    
                    return newState;
                });
                
            let value = {value: response.data.id, label: response.data.title};

            if(this.isMultiple())
                value = [..._.if_empty(this.current_value, []), value];

            this._onChange(value);
        }

        this._toggleForm();
    }
    
    render() {
        if(!this.props.action)
            return super.render();

        let element = this.getElement();
        
        if(_.is_empty(element))
            return null;

        return <View className={[styles['flex-direction-row']]}>
            {this.state.show_form && <this.props.action.element.type {...this.props.action.element.props} ignore_router_params={true} goBack={this._goBack} />}
            {super.render()}
            {React.isValidElement(this.props.action.trigger) && !this.props.disabled ? <this.props.action.trigger.type {...this.props.action.trigger.props} onPress={this._toggleForm} /> : <TouchableArea onPress={this._toggleForm} {...this.props.action.trigger}>{this.props.action.trigger.content}</TouchableArea>}
        </View>
    }
}